import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { App } from './App.js'
import { DostawcaSesji } from './dane/sesja.js'
import { DostawcaToastow } from './ui/Toast.js'
import './style/global.css'

const korzen = document.getElementById('root')
if (korzen === null) throw new Error('Brak elementu #root')

createRoot(korzen).render(
  <StrictMode>
    <BrowserRouter>
      <DostawcaToastow>
        <DostawcaSesji>
          <App />
        </DostawcaSesji>
      </DostawcaToastow>
    </BrowserRouter>
  </StrictMode>,
)

// Rejestracją service workera zajmuje się `useAktualizacja`, żeby wykrywanie
// nowej wersji i samo jej wdrożenie miały jedno miejsce w kodzie.
